
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/settings/integrations",
      function () {
        return require("private-next-pages/settings/integrations.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/settings/integrations"])
      });
    }
  